import "./Careers.module.css";
import VoltMainHeader from "@/reusable_sections/Header";
import StudyMbbsInBarbados from "./sections/StudyMbbsInBarbados";
import OurCommitmentToYou from "./sections/OurCommitmentToYou";
import SynthesisRequestForm from "./sections/SynthesisRequestForm";
import ComprehensiveFooter from "@/reusable_sections/Footer";
export default function CareersPage() {
  return <div>
      <VoltMainHeader />
      <StudyMbbsInBarbados />
      <OurCommitmentToYou />
      <SynthesisRequestForm />
      <ComprehensiveFooter />
    </div>;
}